import request from '@/utils/request'

// 获取公司列表
export function getCompanys() {
  return request({
    url: '/car/role/getCompanys',
    method: 'get',
  })
}
// 获取角色列表
export function getRoleList(data) {
  return request({
    url: '/car/role/getRoleList',
    method: 'get',
    params:data
  })
}
// 新增角色
export function addRole(data) {
  return request({
    url: '/car/role/add',
    method: 'post',
    data
  })
}
// 修改角色
export function updateRole(data) {
  return request({
    url: '/car/role/update',
    method: 'post',
    data
  })
}
// 修改角色状态（停用、启动、删除）
export function upRoleStatus(data) {
  return request({
    url: '/car/role/upStatus',
    method: 'post',
    params:data
  })
}
// 获取角色的权限
export function getPermissions(data) {
  return request({
    url: '/car/permission/getPermissions',
    method: 'get',
    params:data
  })
}
// 修改角色权限
export function setPermissions(data) {
  return request({
    url: '/car/permission/setPermissions',
    method: 'post',
    params:data
  })
}
// 修改角色数据权限
export function upLevel(data) {
  return request({
    url: '/car/permission/upLevel',
    method: 'post',
    params:data
  })
}
// 权限管理中获取账号列表
export function getUserByRole(data) {
  return request({
    url: '/car/permission/getUserByRole',
    method: 'get',
    params:data
  })
}
// 删除用户的角色
export function deleteUserRole(data) {
  return request({
    url: '/car/permission/deleteUserRole',
    method: 'post',
    params:data
  })
}
// 角色添加账号-列表
export function getAddUsers(data) {
  return request({
    url: '/car/role/getAddUsers',
    method: 'get',
    params:data
  })
}
// 角色添加账号
export function addRUsers(data) {
  return request({
    url: '/car/role/addRUsers',
    method: 'post',
    params:data
  })
}